<template lang="pug">
  CommonSection.b-finance-page(
    title="Финансы"
    data-testid="finance-page"
    :back="{ title: project && project.name, name: 'project-stages', params: { projectId } }"
    )
    ._block(v-if="block")
      ._subtitle Комплектация
      ._numbers
        ._number
          ._label Комиссия с заказчика по оплаченным
          ._value(data-testid="finance-commission") {{ money(block.commissionTotal) }}
        ._number
          ._label Вознаграждение начислено
          ._value(data-testid="finance-reward-accrued") {{ money(block.rewardAccrued) }}
        ._number
          ._label Вознаграждение получено
          ._value(data-testid="finance-reward-received") {{ money(block.rewardReceived) }}
        ._number
          ._label Доход от комплектации
          ._value(data-testid="finance-income") {{ money(block.designerIncome) }}

      ._table-title Ожидаемое по поставщикам
      table._table
        thead
          tr
            th Поставщик
            th Начислено
            th Получено
            th Ожидается
            th Контакты
        tbody
          tr(v-for="row in block.expectedBySupplier" :key="row.supplier.id" data-testid="finance-expected-row")
            td(data-testid="finance-expected-supplier") {{ row.supplier.name }}
            td(data-testid="finance-expected-accrued") {{ money(row.rewardAccrued) }}
            td(data-testid="finance-expected-received") {{ money(row.rewardReceived) }}
            td(data-testid="finance-expected-expected") {{ money(row.rewardExpected) }}
            td(data-testid="finance-expected-contacts") {{ contacts(row.supplier) }}
          tr(v-if="!block.expectedBySupplier.length")
            td(colspan="5") Пока нет оплаченных позиций

      ._table-title Закуп по категориям
      table._table
        thead
          tr
            th Категория
            th Сумма
            th Доля
        tbody
          tr(v-for="row in block.purchaseByCategory" :key="row.category" data-testid="finance-category-row")
            td(data-testid="finance-category-name") {{ categoryTitle(row.category) }}
            td(data-testid="finance-category-total") {{ money(row.total) }}
            td(data-testid="finance-category-share") {{ percent(row.share) }}
          tr(v-if="!block.purchaseByCategory.length")
            td(colspan="3") Пока нет заказанных позиций

      ._tops
        ._top
          ._table-title Топ поставщиков по сумме закупа
          ._top-row(v-for="row in block.topSuppliers.byCustomerTotal" :key="row.supplier.id" data-testid="finance-top-customer-row")
            span(data-testid="finance-top-supplier") {{ row.supplier.name }}
            span(data-testid="finance-top-value") {{ money(row.total) }}
        ._top
          ._table-title Топ поставщиков по вознаграждению
          ._top-row(v-for="row in block.topSuppliers.byReward" :key="row.supplier.id" data-testid="finance-top-reward-row")
            span(data-testid="finance-top-supplier") {{ row.supplier.name }}
            span(data-testid="finance-top-value") {{ money(row.total) }}
</template>

<script>
import CommonSection from '@/components/CommonSection.vue';
import specificationApi from '@/api/specification';
import { money, percent, categoryTitle } from '@/utils/spec';

/**
 * Вкладка «Финансы» (ТЗ 6.4): в MVP один блок «Комплектация» (7.3) — только чтение, все числа
 * вычисляет сервер одним ответом. Сгенерировано Claude.
 */
export default {
  name: 'FinancePage',
  components: { CommonSection },
  props: {
    project: Object,
  },
  data() {
    return {
      block: null,
    };
  },
  computed: {
    projectId() { return Number(this.$route.params.projectId); },
  },
  watch: {
    projectId: {
      immediate: true,
      handler() { this.load(); },
    },
  },
  methods: {
    money,
    percent,
    categoryTitle,
    load() {
      specificationApi.fetchProcurement(this.projectId, true)
        .then((block) => { this.block = block; });
    },
    contacts(supplier) {
      return [supplier.contactPerson, supplier.phone, supplier.email]
        .filter((value) => !!value)
        .join(' · ');
    },
  },
};
</script>

<style scoped lang="scss">
.finance-page {
  &__subtitle {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 16px;
  }

  &__numbers {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 30px;
  }

  &__number {
    flex: 1 1 220px;
    padding: 16px 18px;
    border-radius: 8px;
    background: var(--color-white);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.06);
  }

  &__label {
    font-size: 12px;
    color: var(--color-middle-gray);
    margin-bottom: 6px;
  }

  &__value {
    font-size: 24px;
    font-weight: 700;
  }

  &__table-title {
    font-size: 16px;
    font-weight: 700;
    margin: 20px 0 10px;
  }

  &__table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    background: var(--color-white);

    th,
    td {
      text-align: left;
      padding: 8px 12px;
      border-bottom: 1px solid var(--color-super-light);
    }

    th {
      color: var(--color-middle-gray);
      font-weight: 400;
    }
  }

  &__tops {
    display: flex;
    gap: 40px;
    flex-wrap: wrap;
  }

  &__top {
    flex: 1 1 280px;
  }

  &__top-row {
    display: flex;
    justify-content: space-between;
    padding: 6px 0;
    border-bottom: 1px solid var(--color-super-light);
    font-size: 13px;
  }
}
</style>
